import gql from "graphql-tag";

export default gql`
  query GlobalCorporateActions($tickerSymbols: [TickerSymbol!]!, $securityCountry: SecurityCountry!) {
    stockSplit(tickerSymbols: $tickerSymbols, country: $securityCountry) {
      tickerSymbol
      declarationDate
      excludingDate
      splitFrom
      splitTo
    }

    rightsIssues(tickerSymbols: $tickerSymbols, country: $securityCountry) {
      tickerSymbol
      excludingDate
      recordDate
      payDate
      newShare
      subscriptionPrice
    }

    spinOff(tickerSymbols: $tickerSymbols, country: $securityCountry) {
      tickerSymbol
      excludingDate
      recordDate
      payDate
      spinFrom
      spinTo
      numberOfShares
      childCompanyName
      childCompanyExchangeId
      childCompanySymbol
    }
  }
`;
